/** Remap ambiguous legacy Opie team labels to distinguished names. */
export const OPIE_TEAM_NAME_ALIASES = {
  "Opie / Hawke": "E. Opie / Hawke",
  "Bajzik / Opie": "Bajzik / B. Opie",
  "Opie / O'Brien": "R. Opie / O'Brien",
};

export const normalizePoolTeamName = (teamName) =>
  OPIE_TEAM_NAME_ALIASES[teamName] || teamName;

export const normalizePoolTeamNames = (teams) => {
  if (!Array.isArray(teams)) return teams;
  return teams.map(normalizePoolTeamName);
};
